import React, { useState } from "react";
import { Link } from "react-router-dom";

//import images
import logoSm from "../assets/images/logo-sm.png";
import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.png";

//import Components
import MobileMenuOffcanvas from "../Components/Navigation/MobileMenuOffcanvas";

/**
 * Header — logo + mobile hamburger only.
 * In the TopDock layout the logo + structure are styled by top-dock-layout.scss
 * (self-contained); the search box + a duplicate profile menu used to live here
 * but were always hidden by the layout, so they were removed 2026-06-22. The
 * visible profile menu is rendered by TopDockLayout (.top-dock-profile).
 */
const Header = ({ headerClass }: any) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen((o) => !o);
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={headerClass}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex align-items-center">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/admin-dashboard" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoDark} alt="" height="17" />
                  </span>
                </Link>

                <Link to="/admin-dashboard" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="" height="17" />
                  </span>
                </Link>
              </div>

              {/* Mobile menu toggle — visible only below md (768px); hidden on
                  desktop where the top-dock nav is the single nav. Visibility is
                  controlled in top-dock-layout.scss (.mobile-menu-toggle), NOT by a
                  tw- class: src/Layouts is outside Tailwind's `content` globs, so a
                  `md:tw-hidden` here is never generated and silently does nothing. */}
              <button
                onClick={toggleMobileMenu}
                type="button"
                className="mobile-menu-toggle tw-flex tw-items-center tw-self-stretch tw-border-0 tw-bg-transparent tw-px-3 tw-text-base tw-cursor-pointer"
                id="mobile-menu-toggle"
                aria-label="Toggle mobile menu"
                aria-expanded={mobileMenuOpen}
              >
                <i className="ri-menu-line" style={{ fontSize: "20px" }}></i>
              </button>
            </div>
          </div>
        </div>
      </header>
      {/* Mobile Menu Offcanvas */}
      <MobileMenuOffcanvas isOpen={mobileMenuOpen} toggle={toggleMobileMenu} />
    </React.Fragment>
  );
};

export default Header;
